import React from 'react'
import { DropdownMenu, Input, spacer } from 'stylist'
import styled from '@emotion/styled'
import Tooltip from 'components/Tooltip'
import { noop } from 'utils'
import ReactDOM from 'react-dom'

const SearchInput = styled(Input)`
  margin: ${spacer(2)};
`

const DropdownItem = ({
  option,
  onSelect = noop,
  onHover = noop,
  ...props
}) => (
  <DropdownMenu.Item
    {...props}
    data-test="search-dropdown-item"
    onClick={() => onSelect(option.value)}
    onMouseOver={() => onHover(option.value)}
  >
    {option.title}
  </DropdownMenu.Item>
)

class SearchableDropdown extends React.Component {
  state = {
    substring: '',
    activeTooltip: ''
  }

  handleToggle = opened => {
    const { onToggle } = this.props
    if (this.state.substring) {
      this.setState({ substring: '' })
    }
    onToggle(opened)
  }

  render() {
    const { options, onSelect, onHover, onToggle, ...props } = this.props
    return (
      <DropdownMenu onToggle={this.handleToggle} {...props}>
        <SearchInput
          data-test="search-dropdown-input"
          onChange={({ target: { value } }) =>
            this.setState({ substring: value })
          }
          value={this.state.substring}
        />
        {options
          .filter(opt =>
            opt.title.toLowerCase().includes(this.state.substring.toLowerCase())
          )
          .map((option, index) =>
            option.tooltip ? (
              <Tooltip
                key={index}
                id={option.value}
                place="right"
                contents={option.tooltip}
              >
                <DropdownItem
                  option={option}
                  onSelect={onSelect}
                  onHover={onHover}
                />
              </Tooltip>
            ) : (
              <DropdownItem
                key={index}
                option={option}
                onSelect={onSelect}
                onHover={onHover}
              />
            )
          )}
      </DropdownMenu>
    )
  }
}

export default SearchableDropdown



// WEBPACK FOOTER //
// ./src/components/SearchableDropdown.js